// extracted by mini-css-extract-plugin
module.exports = {"FooterLogo":"styles_FooterLogo__yFiim","logo":"styles_logo__k7op8","theme-amber":"styles_theme-amber__mrQAS"};